import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import axios from "axios";
import VueAxios from "vue-axios";

import { config } from "../config";
import { BootstrapVue, BootstrapVueIcons } from "bootstrap-vue";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
import { library } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { faUserSecret } from "@fortawesome/free-solid-svg-icons";
import "bootstrap-icons/font/bootstrap-icons.css";

import { rtdbPlugin } from "vuefire";
import { firestorePlugin } from "vuefire";

Vue.use(firestorePlugin);
Vue.use(rtdbPlugin);
library.add(faUserSecret);
Vue.use(VueAxios, axios);
Vue.component("font-awesome-icon", FontAwesomeIcon);
Vue.config.productionTip = false;
Vue.use(BootstrapVue);
Vue.use(BootstrapVueIcons);

Vue.config.productionTip = false;

Vue.prototype.$domainfront =
  window.location.host == "localhost:8080"
    ? config.FRONT_URL_DEV
    : config.FRONT_URL_PROD;

Vue.prototype.$domain =
  window.location.host == "localhost:8080"
    ? config.API_URL_DEV
    : config.API_URL_PROD;

axios.defaults.baseURL =
  window.location.host == "localhost:8080"
    ? config.API_URL_DEV
    : config.API_URL_PROD;

Vue.prototype.$queue_url = config.QUEUE_URL;

Vue.prototype.$dga_domain =
  window.location.host == "localhost:8080"
    ? "https://connect.dga.or.th"
    : "https://connect.egov.go.th";

Vue.prototype.$site = config.SITE;
Vue.prototype.$ADDR = config.ADDR;

if (config.SITE == "ssj_nont") {
  Vue.prototype.$client_secret = "UuUId8HSniS";
  Vue.prototype.$client_id = "6be55f8c-b25e-4227-ba95-0bf7301b7b6f";
} else if (config.SITE == "ssj_angthong") {
  Vue.prototype.$client_secret = "fBst4NJAAqi";
  Vue.prototype.$client_id = "55dd157d-4c07-410c-b2e3-e6dd106d7b5a";
} else if (config.SITE == "ssj_npt") {
  Vue.prototype.$client_secret = "Bdo1G1FVoJe";
  Vue.prototype.$client_id = "c94fbc53-145f-4522-931c-d4137a377631";
}

Vue.prototype.$logo = config.LOGO;

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
